import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IRequestPermissionStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  buttons?: IStyle;
}

export interface IRequestPermissionClassNames {
  root: string;
  form: string;
  fields: string;
  buttons: string;
}

export const requestPermissionStylesDefault = (_theme: IH2OTheme): Partial<IRequestPermissionStyles> => ({
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  buttons: { textAlign: 'right' },
});
